// extracted by mini-css-extract-plugin
export default {"root":"DecisionList-root-ed4ee20024513c33238f841965b14c8b"};